import React from 'react';
interface StatusBadgeProps {
  type: 'status' | 'priority';
  value: string;
}
export function StatusBadge({
  type,
  value
}: StatusBadgeProps) {
  let colorClasses = '';
  if (type === 'status') {
    switch (value) {
      case 'New':
        colorClasses = 'bg-blue-100 text-blue-700 border-blue-200';
        break;
      case 'In Progress':
        colorClasses = 'bg-amber-100 text-amber-700 border-amber-200';
        break;
      case 'Waiting on User':
        colorClasses = 'bg-orange-100 text-orange-700 border-orange-200';
        break;
      case 'Resolved':
        colorClasses = 'bg-green-100 text-green-700 border-green-200';
        break;
      default:
        colorClasses = 'bg-gray-100 text-gray-700 border-gray-200';
    }
  } else if (type === 'priority') {
    switch (value) {
      case 'Low':
        colorClasses = 'bg-gray-100 text-gray-600 border-gray-200';
        break;
      case 'Medium':
        colorClasses = 'bg-blue-100 text-blue-600 border-blue-200';
        break;
      case 'High':
        colorClasses = 'bg-amber-100 text-amber-600 border-amber-200';
        break;
      case 'Critical':
        colorClasses = 'bg-red-100 text-red-600 border-red-200';
        break;
      default:
        colorClasses = 'bg-gray-100 text-gray-600 border-gray-200';
    }
  }
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${colorClasses}`} data-id="element-158">
      <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${colorClasses.replace('bg-', 'bg-').replace('text-', 'bg-').split(' ')[1]}`} data-id="element-159"></span>
      {value}
    </span>;
}